export enum ContactType {
    EMERGENCY = "EMERGENCY",
    STANDARD = "STANDARD",
    ALTERNATIVE_PICKUP = "ALTERNATIVE_PICKUP"
}